import { ContentCopy } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { getBankAccount } from 'lib/api/paymentLink';
import React from 'react';

interface WireInformationProps {
  encryptedCompanyId: string;
  encryptedBusinessIdentifier: string;
}

const WireInformation: React.FC<WireInformationProps> = (props) => {
  const { data, isLoading } = getBankAccount(
    props.encryptedCompanyId,
    props.encryptedBusinessIdentifier,
  );
  const bankName = data?.bankName ?? '';
  const accountNumber = data?.accountNumber ?? '';
  const accountType = data?.accountType ?? '';
  const legalName = data?.holderName ?? '';
  const identifier = data?.holderIdentifier ?? '';
  const email = data?.email ?? '';

  return (
    <div
      style={{
        border: 'solid 1px ',
        borderColor: '#e0e0e0',
        borderRadius: '7px',
        backgroundColor: '#FFFF',
        marginTop: '46px',
        width: '100%',
      }}
    >
      {!isLoading && (
        <div style={{ padding: '8px 24px' }}>
          <Typography
            variant="h4"
            style={{ textAlign: 'center' }}
            fontWeight="bold"
          >
            🏦 Datos bancarios
          </Typography>

          <div style={{ padding: '24px' }}>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {legalName}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {identifier}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {accountNumber}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {accountType}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {bankName}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
              {email}
            </Typography>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Button
              variant="text"
              startIcon={<ContentCopy />}
              onClick={() =>
                void navigator.clipboard.writeText(
                  `${legalName}\n${identifier}\n${bankName}\n${accountNumber}\n${accountType}`,
                )
              }
            >
              Copiar datos
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WireInformation;
